import React from 'react';
import { css, cx } from '@linaria/core';
import { Alert, Link } from '@livecommerce/design-system';
import { useLocalization } from 'contexts/LocalizationContext.jsx';

const alertStyle = css`
  width: calc(100% - 16px);
  height: 56px;
  margin: 8px;
  border-radius: 8px;
  grid-column: 1 / 3;
  grid-row: 1 / 2;
`;

const textContainerStyle = css`
  width: 100%;
`;

const descriptionStyle = css`
  width: 100%;
`;

const titleStyle = css`
  text-align: center;
  width: 100%;
`;

const linkStyle = css`
  color: white;
`;

const linkClassName = cx('notranslate', linkStyle);

const BillingAlert = ({ isDeactivated }) => {
  const { t } = useLocalization();
  const linkVariant = 'linkBold';
  const variant = 'danger';
  const href = 'mailto:invoice@bambuser.com';
  return (
    <Alert
      dataTestId="billingNotificationBanner"
      title={
        isDeactivated ? (
          <>
            {t('billingAlert.deactivatedAlertText')}{' '}
            <Link className={linkClassName} variant={linkVariant} href={href}>
              invoice@bambuser.com
            </Link>{' '}
            {t('billingAlert.secondAlertText')}
          </>
        ) : (
          <>
            {t('billingAlert.firstAlertText')}{' '}
            <Link className={linkClassName} variant={linkVariant} href={href}>
              invoice@bambuser.com
            </Link>{' '}
            {t('billingAlert.secondAlertText')}
          </>
        )
      }
      variant={variant}
      className={alertStyle}
      textContainerProps={{ className: textContainerStyle }}
      titleProps={{ className: titleStyle }}
      descriptionProps={{ className: descriptionStyle }}
    />
  );
};

export default BillingAlert;
